import React from 'react';
import { useDb } from '../utils/DbContext';

const DbSwitcher = () => {
  const { dbName, setDbName, allowedDbs } = useDb();

  const onChange = (e) => {
    const next = e.target.value;
    if (next === dbName) return;
    setDbName(next);
    window.location.reload();
  };

  return (
    <select
      className="db-switcher"
      value={dbName}
      onChange={onChange}
      title="Active database"
    >
      {allowedDbs.map((name) => (
        <option key={name} value={name}>
          {name}
        </option>
      ))}
    </select>
  );
};

export default DbSwitcher;
